<template>
  <div class="bg-white shadow-lg rounded-lg pointer-events-auto z-50">
    <div class="rounded-lg shadow-xs overflow-hidden">
      <div class="p-4">
        <div class="flex items-start">
          <div class="flex-shrink-0">
            <alert-icon class="h-6 w-6 text-red-600 bg-red-200 p-1 rounded-full" v-if="isError" />
            <check-icon class="h-6 w-6 text-green-600 bg-green-200 p-1 rounded-full" v-else />
          </div>
          <div class="ml-3 w-0 flex-1 pt-0.5">
            <p class="leading-5 text-gray-900 font-thin mb-0">{{ title }}</p>
            <p class="mt-1 text-sm leading-5 text-gray-500 font-light mb-0">{{ message }}</p>
          </div>
          <div class="ml-4 flex-shrink-0 flex">
            <button @click="$emit('remove')" class="inline-flex text-gray-400 focus:outline-none focus:text-gray-500 transition ease-in-out duration-150">
              <x-icon class="h-5 w-5" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { XIcon, CheckIcon, AlertIcon } from "@/assets/svgs";

export default {
  components: {
    XIcon,
    CheckIcon,
    AlertIcon,
  },
  props: {
    id: Number,
    title: {
      type: String,
      required: true,
    },
    message: String,
    isError: Boolean,
  },
};
</script>
